import axios from "axios";

export const brandsData = () => {
  return axios.get("/brands").then((response) => {
    // console.log(response.data);
    return response;
  });
};
